import { IsNotEmpty, IsUUID } from 'class-validator';

export class GetDocumentHashDto {
  @IsNotEmpty()
  @IsUUID()
  policyId: string;

  @IsNotEmpty()
  @IsUUID()
  policyVersionId: string;
}
